import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  Wrapper,
  PageContent,
  Title,
  Input,
  Button,
  ButtonPlaceholder,
  Text,
  Anchor,
  Spinner,
} from './SignUpPage.style';

import { WHITE } from '../../../styles/variables.style';

import Placeholder from '../../../components/Placeholder';

const image = {
  title: 'Seminar Photo Gallery',
  description: 'Seminar Photo Gallery',
  file: {
    url:
      'https://images.ctfassets.net/qf666eyypqhw/1qanwtJ3SEuKSuiiKkIaYQ/a1f2dcc94b1ee96288c60e58dac36b19/pattern.jpg',
    details: { size: 3813, image: { width: 900, height: 1024 } },
    fileName: 'stylist_tool_login_pattern.jpg',
    contentType: 'image/jpeg',
  },
};

const CodeForm = ({ copy, onInputChange, onCodeSubmit, isValidCodeForm, locale, code, loading, error }) => (
  <Wrapper bg={image.file.url} w={image.file.details.image.width}>
    <PageContent>
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Title>{copy.sign_up_1}</Title>
      ) : (
        <div>
          <Placeholder h="40px" w="500px" />
        </div>
      )}
      <form onSubmit={onCodeSubmit} style={{ display: 'block' }}>
        <Input type="text" placeholder={copy.code_placeholder} value={code} onChange={onInputChange('code')} />
        <p style={{ fontSize: '14px', color: WHITE }}>
          {copy.signup_terms}{' '}
          <Link
            to={`/${locale}/terms-of-use`}
            href={`/${locale}/terms-of-use`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '14px', color: WHITE, fontWeight: '800', textDecoration: 'underline' }}
          >
            {copy.signup_terms_link}
          </Link>
        </p>
        {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
        {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
          <Button type="submit" disabled={!isValidCodeForm() || loading}>
            {loading ? <Spinner /> : copy.submit}
          </Button>
        ) : (
          <ButtonPlaceholder>
            <Placeholder h="65px" w="300px" />
          </ButtonPlaceholder>
        )}
      </form>
      {Object.keys(copy).length !== 0 && copy.constructor === Object ? (
        <Text>
          {copy.already_have_account}
          <Link to={`/${locale}/stylist/login`} href={`/${locale}/stylist/login`}>
            <Anchor>{copy.sign_in}</Anchor>
          </Link>
        </Text>
      ) : (
        <div>
          <Placeholder h="25px" w="250px" />
        </div>
      )}
    </PageContent>
  </Wrapper>
);

CodeForm.defaultProps = {
  copy: {},
  loading: false,
  error: '',
};

CodeForm.propTypes = {
  copy: PropTypes.shape({}),
  onInputChange: PropTypes.func.isRequired,
  onCodeSubmit: PropTypes.func.isRequired,
  isValidCodeForm: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

export default CodeForm;



// WEBPACK FOOTER //
// ./src/pages/StylistToolPages/SignUpPage/CodeForm.js